import './index.scss';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import BookRoomInfo from '../../pages/book-room/BookRoomInfo';
import InvitedUsers from '../../pages/book-room/InvitedUsers';
import { getHourFromTimeStampOption } from '../../../utility/Utils';
import BookSuccessMessage from '../../pages/book-room/BookSuccessMessage';
import {
  useCloseOldModal,
  useModalData,
} from '../../../store/modal/modalHooks';
import ModifyRoomFormContainer from '../../pages/book-room/ModifyRoomFormContainer';
import CancellationPolicy from '../../shared/cancellation-policy/CancellationPolicy';
import BookContainer from '../../shared/book-components/BookModalComponent/BookModalComponent';
import { MyActivityResourceImpl } from '../../../API/my-activities/implements/my-activity-resource.impl';

const ViewRoomModal = () => {
  const modalData = useModalData();
  const activity: MyActivityResourceImpl = modalData?.data.activity;

  const closeModal = useCloseOldModal();
  const [showSuccessPage, setShowSuccessPage] = useState(false);
  const [showCancellationPolicy, setShowCancellationPolicy] = useState(false);
  const [showInvitedUsers, setShowInvitedUsers] = useState(false);

  if (!activity) {
    closeModal();
  }

  const defaultValues = {
    date: [activity?.alloc ? new Date(activity?.alloc.startTime) : new Date()],
    start: getHourFromTimeStampOption(activity?.alloc?.startTime),
    end: getHourFromTimeStampOption(activity?.alloc?.endTime),
    numberOfParticipants: activity?.alloc?.numberOfParticipants,
    messageForAdmin: activity.alloc.admin_message || '',
    invited_users:
      activity.alloc.invited_users &&
      activity.alloc.invited_users.map((user) => user.userId),
    departmentName: activity.alloc.department_name || '',
    meetingSubject: activity.alloc.meeting_subject || '',
  };

  const form = useForm({ defaultValues });
  const {
    reset,
    formState: { errors },
  } = form;

  useEffect(() => {
    reset({
      date: [
        activity?.alloc ? new Date(activity?.alloc.startTime) : new Date(),
      ],
      start: getHourFromTimeStampOption(activity?.alloc?.startTime),
      end: getHourFromTimeStampOption(activity?.alloc?.endTime),
      numberOfParticipants: activity?.alloc?.numberOfParticipants,
      messageForAdmin: activity.alloc.user_message || '',
      invited_users:
        activity.alloc.invited_users &&
        activity.alloc.invited_users.map((user) => user.userId),
      departmentName: activity.alloc.department_name || '',
      meetingSubject: activity.alloc.meeting_subject || '',
    });
  }, [activity]);

  return activity ? (
    <div className="book-room-modal">
      <BookContainer
        infoComponent={
          !showCancellationPolicy ? (
            <BookRoomInfo
              alloc={activity?.alloc}
              room={activity?.resource!}
              form={form}
            />
          ) : (
            <CancellationPolicy policyId={activity?.resource?.policyId} />
          )
        }
        formComponent={
          showSuccessPage ? (
            <BookSuccessMessage />
          ) : showInvitedUsers ? (
            <InvitedUsers
              showBookInfo={() => setShowInvitedUsers(false)}
              form={form}
            />
          ) : (
            <ModifyRoomFormContainer
              activity={activity}
              form={form}
              room={activity.resource}
              activityId={activity?.alloc?.id!}
              setShowSuccessPage={setShowSuccessPage}
              setShowCancellationPolicy={setShowCancellationPolicy}
              showCancellationPolicy={showCancellationPolicy}
              item={activity?.item}
              onClickInvitedUsers={() => setShowInvitedUsers(true)}
            />
          )
        }
      />
    </div>
  ) : null;
};
export default ViewRoomModal;
